import React from 'react';
import { BaseCard } from './BaseCard';
import {
  fetchPageBreakdown,
  fetchReferrerBreakdown,
  IReferrerBreakdown,
  IPageBreakdown
} from '../../../api';

/**
 * Top page views
 */
export const TopPagesCard = () => {
  return (
    <BaseCard<IPageBreakdown>
      title="Top page views"
      maxItems={10}
      itemsProvider={fetchPageBreakdown}
      getKey={(item) => item.page}
      getLabel={(item) => item.page}
      getValue={(item) => item.views}
      className="card flex-fill d-flex flex-column"
    />
  );
};

/**
 * Top page views
 */
export const TopReferrerCard = () => {
  return (
    <BaseCard<IReferrerBreakdown>
      title="Top sources"
      maxItems={10}
      itemsProvider={fetchReferrerBreakdown}
      getKey={(item) => item.referrer}
      getLabel={(item) => item.referrer}
      getValue={(item) => item.count}
      className="card flex-fill d-flex flex-column"
    />
  );
};
